import { Pipe, PipeTransform } from '@angular/core';

/** Colour variants available on the `.detail-pill` component. */
export type StatusPillVariant =
  | 'success'
  | 'warn'
  | 'danger'
  | 'info'
  | 'neutral';

const DANGER = /NOTOK|NOT-OK|REJECT|FAIL|CANCEL|INACTIVE|BLOCK|DECLIN|EXPIRE/;
const WARN = /PENDING|PARTIAL|CREATED|HOLD|REVIEW|INITIAT|AWAIT/;
const INFO = /PROCESS|PROGRESS/;
const SUCCESS = /\bOK\b|-OK|ACTIVE|PAID|SUCCESS|COMPLET|VERIFI|APPROVE|DONE/;

/** Maps a backend status string onto a pill colour variant. */
export const statusPillVariant = (
  value?: string | boolean | null
): StatusPillVariant => {
  if (typeof value === 'boolean') return value ? 'success' : 'neutral';
  const status = (value ?? '').trim().toUpperCase();
  if (!status) return 'neutral';
  // Order matters: "INACTIVE"/"NOTOK" would otherwise match the success rule.
  if (DANGER.test(status)) return 'danger';
  if (WARN.test(status)) return 'warn';
  if (INFO.test(status)) return 'info';
  if (SUCCESS.test(status)) return 'success';
  return 'neutral';
};

/**
 * Resolves the `.detail-pill--*` modifier for a status value, so detail
 * templates can colour a pill without repeating ngClass maps.
 *
 * Usage: `<span class="detail-pill" [ngClass]="status | statusPill">`
 */
@Pipe({
  name: 'statusPill',
  standalone: true,
})
export class StatusPillPipe implements PipeTransform {
  transform(value?: string | boolean | null): string {
    return `detail-pill--${statusPillVariant(value)}`;
  }
}
